import { render, staticRenderFns } from "./Form_Item.vue?vue&type=template&id=2dfa4529&scoped=true"
import script from "./Form_Item.vue?vue&type=script&lang=js"
export * from "./Form_Item.vue?vue&type=script&lang=js"
import style0 from "./Form_Item.vue?vue&type=style&index=0&id=2dfa4529&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa4529",
  null
  
)

export default component.exports